<template>
  <drag tag="tr" v-bind:class="{ tr: true, 'has-issues': isDisabled }" :transfer-data="rsvp" :draggable="!inMap"
    @dragstart="dragFn(true)" @dragend="dragFn(false)" v-if="!isMobile">
    <div slot="image" class="dragslot">Reservation {{ rsvp.id }}</div>
    <td class="check">
      <!-- <input type="checkbox" v-model="selected" :value="rsvp.id" /> -->
    </td>
    <td class="map-button pkg-map">
      <a href="javascript:;" @click="toggleInMap" :class="{ selected: inMap }">
        <i class="fas fa-map-marker-alt"></i>
        <!-- <i class="fas fa-pen"></i> -->
      </a>
    </td>
    <td class="ids">
      <a :href="`/#/reservation/${rsvp.id}`" target="_blank" class="rsvp-id">{{rsvp.id}}</a>
      <div class="tool-tip-box">
        <img v-if="rsvp.isOptinShared" src="../../assets/img/shared-ride-blue.png" class="optin-icon" />
        <span>Opted in to a shared service</span>
      </div>
    </td>
    <td class="date">{{ rsvp.pickupDate }}</td>
    <td class="locs pickup">{{ getAddress(rsvp.pickup) }}</td>
    <td class="locs dropoff">{{ getAddress(rsvp.dropoff) }}</td>
    <td class="driver-payment">${{ parseFloat(rsvp.driverPayment.toFixed(2)) }}</td>
    <td class="flight-info">
      <div v-if="rsvp.flightInfo">
        <a @click="showFlightInfo(rsvp)">{{rsvp.flightInfo.airline}} {{rsvp.flightInfo.flightNo}}</a>
        <img src="/assets/img/departure.png" v-if="rsvp.flightInfo.isDeparture" />
        <img src="/assets/img/arrival.png" v-else />
      </div>
    </td>
    <td class="pax">{{rsvp.pax}}</td>
    <td class="service">
      <span class="service-type" :style="{background: rsvp.service.color}">{{ rsvp.service.name }}</span>
    </td>
  </drag>
  <div v-else class="table-card">
    <div class="row-1">
      <div>
        <a :href="`/#/reservation/${rsvp.id}`" target="_blank" class="rsvp-id">{{rsvp.id}}</a>
        <span class="service-type" :style="{background: rsvp.service.color}">{{ rsvp.service.name }}</span>
      </div>
      <div class="map-button"  @click="toggleInMap">
        <a href="javascript:;"
        v-bind:class="{ selected: inMap }">
          <i class="fas fa-map-marker-alt"></i>
        </a>
      </div>
    </div>
    <div>
      <div>Pickup Time: {{ rsvp.pickupDate }}</div>
    </div>
    <div v-if="rsvp.flightInfo" class="flight-info">
      <div>
        <a @click="showFlightInfo(rsvp)">{{rsvp.flightInfo.airline}} {{rsvp.flightInfo.flightNo}}</a>
        <img src="/assets/img/departure.png" v-if="rsvp.flightInfo.isDeparture" />
        <img src="/assets/img/arrival.png" v-else />
      </div>
    </div>
    <div class="row-4">
      <div class="pickup">
        <i class="fas fa-map-marker-alt icon"></i>
        {{ getAddress(rsvp.pickup) }}
      </div>
    </div>
    <div class="row-5">
      <div class="dropoff">
        <i class="fas fa-location-arrow icon"></i>
        <span>{{ getAddress(rsvp.dropoff) }}</span>
      </div>
    </div>
    <div>
      <div>Driver Payment: ${{ parseFloat(rsvp.driverPayment.toFixed(2)) }}</div>
    </div>
    <div v-if="rsvp.pax">
      PAX: {{rsvp.pax}}
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import request from 'browser-request'
import ft from '@/modules/api/featureToggle'

export default {
  name: 'exclusive-row',
  props: ['rsvp', 'isMobile'],
  data () {
    return {
      isDisabled: false
    }
  },
  computed: {
    airports () { return this.$store.state.airports.list },
    inMap () {
      let mapItems = this.$store.state.runs.dropzone.items
      let item = mapItems.filter(mapItem => mapItem.id === this.rsvp.id)
      return item.length > 0
    },
    dropzoneItems () { return this.$store.state.runs.dropzone.items }
  },
  methods: {
    dragFn (showDropzone) {
      this.$store.commit('runs/setDropzoneData', {show: showDropzone})
    },
    getAddress (loc) {
      let index = this.airports.findIndex(x => x.geofenceId === loc.geofenceId)
      if (index > -1) return this.airports[index].title
      return loc.title
    },
    showFlightInfo (rsvp) {
      if (rsvp.flightInfo.airline === null) return

      let self = this
      self.$store.commit('flightInformation/show')

      let date = moment(rsvp.pickupDate, 'MM/DD/YYYY hh:mmA')
      let airlineDate = encodeURIComponent(date.format('YYYY-MM-DD'))
      let airlineTime = encodeURIComponent(date.format('HH:mm:ss'))
      let flightNumber = rsvp.flightInfo.flightNo
      let isDeparture = `&departure=${rsvp.flightInfo.isDeparture ? '1' : '0'}`
      let url = '/availability/flights/' +
        rsvp.flightInfo.airline + flightNumber +
        '?date=' + airlineDate +
        '&time=' + airlineTime +
        '&airport=' + rsvp.flightInfo.airportCode +
        isDeparture
      self.$sdk.get(url, {}, r => {
        self.$store.commit('flightInformation/setLoading', false)
        if (r.error) {
          self.$store.commit('flightInformation/setFlightInfo', {
            airline: {
              name: rsvp.airline,
              code: rsvp.flightInfo.airline
            },
            flightNumber: flightNumber,
            departure: {
              airportCode: '',
              airportName: '',
              time: ''
            },
            arrival: {
              airportCode: '',
              airportName: '',
              time: ''
            },
            status: 'N/A'
          })
          return
        }

        let isAirportDropoff = rsvp.flightInfo.isDeparture
        let date = isAirportDropoff ? r.departure.time.unix : r.arrival.time.unix
        let arriveDate = moment(date, 'X', r.departure.time.timezone)
        self.$store.commit('flightInformation/setFlightInfo', {
          airline: r.airline || rsvp.flightInfo.airline,
          flightNumber: r.flight.number || rsvp.flightInfo.flightNo,
          departure: {
            airportCode: r.departure.airportCode,
            airportName: r.departure.airportName,
            time: moment(r.departure.time.unix, 'X', r.departure.time.timezone).format('MM/DD/YYYY ' + ft.timeFormat(self, false))
          },
          arrival: {
            airportCode: r.arrival.airportCode,
            airportName: r.arrival.airportName,
            time: arriveDate.format('MM/DD/YYYY ' + ft.timeFormat(self, false))
          },
          status: self.translateFlightStatus(r.status, isAirportDropoff),
          type: isAirportDropoff ? 'departure' : 'arrive'
        })
      })
    },
    translateFlightStatus (status, isAirportDropoff) {
      if (!isAirportDropoff) {
        switch (status) {
          case 'Scheduled': return 'Flight is arriving as scheduled.'
          case 'Proposed': return 'Flight is arriving as scheduled.'
          case 'OutGate': return 'Flight is arriving as scheduled.'
          case 'InAir': return 'Flight is currently on-air.'
          case 'Landed': return 'Flight has already arrived.'
          case 'InGate': return 'Flight has already arrived.'
          case 'Expected': return 'Flight is arriving as scheduled.'
          case 'NoTakeOffInfo': return 'Flight is arriving as scheduled.'
          case 'Delayed': return 'Flight is currently delayed.'
          case 'Cancelled': return 'Flight was cancelled.'
          case 'Unknown': return 'Flight is arriving as scheduled.'
          case 'PastFlight': return 'Flight has already arrived.'
          case 'Original' : return 'Flight is arriving as scheduled.'
        }
        return 'Flight is arriving as scheduled.'
      }

      switch (status) {
        case 'Scheduled': return 'Flight is still scheduled.'
        case 'Proposed': return 'Flight is still scheduled.'
        case 'OutGate': return 'Flight is still scheduled.'
        case 'InAir': return 'Flight is currently on-air.'
        case 'Landed': return 'Flight has already landed.'
        case 'InGate': return 'Flight has already arrived.'
        case 'Expected': return 'Flight is still scheduled.'
        case 'NoTakeOffInfo': return 'Flight is still scheduled.'
        case 'Delayed': return 'Flight is currently delayed.'
        case 'Cancelled': return 'Flight has been cancelled.'
        case 'Unknown': return 'Flight is still scheduled.'
        case 'PastFlight': return 'Flight has already been completed.'
        case 'Original' : return 'Flight is still scheduled.'
      }
      return 'Flight is still scheduled.'
    },
    toggleInMap () {
      let self = this
      if (self.inMap) {
        self.$store.commit('runs/removeDropzoneItems', self.rsvp)
        return
      }
      let rsvp = self.rsvp.rsvps[0]
      self.$store.commit('runs/addDropzoneItem', rsvp)
    },
    hasIssues () {
      let self = this
      if (self.inMap) {
        self.isDisabled = false
        return false
      }
      if (self.dropzoneItems.length <= 0) {
        self.isDisabled = false
        return false
      }
      let lastItem = self.dropzoneItems[self.dropzoneItems.length - 1]
      let url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&transportMode=car&return=polyline,summary'
      url = url.replace('{API_KEY}', CONFIG.hereApi.key)
      url += `&origin=${lastItem.dropoff.lat},${lastItem.dropoff.lng}`
      url += `&destination=${self.rsvp.pickup.lat},${self.rsvp.pickup.lng}`


      let eta = moment(lastItem.pickupDate, 'MM/DD/YYYY hh:mmA').add(lastItem.eta, 'seconds').add(lastItem.timeToNext, 'seconds')
      let nextPickup = moment(self.rsvp.pickupDate, 'MM/DD/YYYY hh:mmA')
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          console.log('ROUTING ERROR', error)
          self.isDisabled = false
          return
        }

        if (!body.routes.length) {
          return
        }
        let routeSections = body.routes[0].sections
        let etaInSec = 0
        for (let i = 0; i < routeSections.length; i++) {
          let section = routeSections[i]
          etaInSec = etaInSec + section.summary.duration
        }
        let newEta = moment(lastItem.pickupDate, 'MM/DD/YYYY hh:mmA').add(lastItem.eta, 'seconds').add(etaInSec, 'seconds')
        if (newEta.isAfter(nextPickup)) {
          self.isDisabled = true
        }
      })
      if (eta.isAfter(nextPickup)) {
        self.isDisabled = true
        return true
      }
      self.isDisabled = false
      return false
    }
  },
  mounted () {
  },
  watch: {
    dropzoneItems (value) {
      let self = this
      if (value.length <= 0) {
        self.isDisabled = false
        return
      }
      self.hasIssues()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_service-types';
.dragslot {
  font-weight: 700;
  background-color: #fff;
  padding: 5px;
  box-shadow: 2px 0 8px rgba(0,0,0,0.25);
  border: 1px solid rgba(0,0,0,0.4);
  border-radius: 3px;
}
.tr{
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);

  &.has-issues { background-color: #dddddd; }

  td{
    padding: 10px 5px;
    text-align: center;
    font-size: 12px;
  }
  input{
    margin-top: 0;
    width: 13px;
  }
  .map-pin{
    color: #fff;
    background-color: #aaa;
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    border-radius: 30px;
    -webkit-transition: all 250ms;
    transition: all 250ms;

    i{
      line-height: 30px;
    }
  }
  .rsvp-id{
    display: block;
    font-size: 13px;
    outline: none;
    font-weight: 600;
    line-height: 1.45;
  }
  .service-type{
    display: block;
    background: #999;
    margin-bottom: 3px;
  }
  .check { width: 30px; }
  .map{ width: 40px; }
  .ids{ width: 90px; }
  .date{ width: 90px; }
  // .locs{ width: 100%; }
  .driver-payment{ width: 110px; }
  .flight-info{
    width: 100px;

    img{ width: 30px; }
    a{
      display: block;
      cursor: pointer;
      font-weight: 600;
    }
  }
  .service{ width: 130px; }
}

.map-button{
  padding: 10px;

  & a{
    color: #fff;
    background-color: #aaa;
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    border-radius: 30px;
    transition: all 250ms;

    & i {line-height: inherit;}

    &.disabled{
      pointer-events: none;
      opacity: 0.5;
      background-color: #bbb;
    }
    &.selected{
      background-color: #26D97A;
    }
  }
}

@media screen and (max-width: 430px) {
  .table-card {
    border: 1px solid #ccc;
    margin: 10px;
    margin-bottom: 15px;
    padding: 10px;
    border-bottom: 5px solid #aaa9;
    border-radius: 10px;
    font-size: 13px;
    background-color: #fff;

    a {
      font-weight: 900;
    }

    i {
      color: #0d79f2;
    }

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 3px;

      &.see-more {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }
    }

    .toggle-div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .toggle {
        font-size: 16px;
        color: #0e79f2;
      }
    }

    .row-1 {
      align-items: center;
      .link {
        padding-bottom: 5px;
        display: inline-block;
      }
      .rtg {
        display: inline-block;
        margin: 4px;
      }
      i {
        color: #26D97A;
      }
      input {
        display: inline-block;
        margin: 0;
        width: 15px;
        height: 15px;
        margin-right: 5px;
      }
      .map-button {
        padding: 0;
        a {
          background-color: #aaa;
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-radius: 30px;
          -webkit-transition: all 250ms;
          transition: all 250ms;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          i {
            color: #fff;
          }
          &.disabled{
            pointer-events: none;
            opacity: 0.5;
            background-color: #bbb;
          }
          &.selected{
            background-color: #26D97A;
          }
        }
      }
    }

    .flight-info {
      img {
        min-width: 30px;
        max-width: 30px;
      }
    }

    .row-2 {
      display: flex;
      justify-content: unset;
      gap: 5px;
      align-items: center;
      .image {
        img {
          min-width: 30px;
          max-width: 30px;
        }
      }
    }

    .row-7 {
      strong {
        color: #666;
      }
      i {
        color: #666;
        margin: 0 3px;
      }
    }

    .row-8 {
      justify-content: center;
      .actions {
        display: flex;
        span {
          padding: 8px 20px;
        }
        .notes {
          i {
            color: #fff;
          }
        }
      }
    }

    .service-type {
      margin: 0 5px;
    }

    .clock {
      i {
        color: #F25E0D;
      }
    }

    .pickup {
      i {
        color: #d92626;
      }
    } 

    .dropoff {
      i {
        color: #26D97A;
      }
    }
  }
}

.tool-tip-box{
  position: relative;

  span{
    display: none;
    position: absolute;
    top: calc(100% + 3px);
    left: -55px;
    line-height: 1.2;
    font-size: 12px;
    border: 1px solid #888;
    background: #fafafa;
    color: #333;
    padding: 3px 5px;
    width: 170px;
    text-align: center;
  }
  i:hover + span, img:hover + span{
    display: block;
  }
}
.optin-icon{
  min-width: 18px!important;
  width: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/Runs/ExclusiveRow.vue